import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OverlayService } from '@core/services';
import { ModalsNames } from '@data/const';
import { DialogWrapperComponent, IconComponent, QrComponent, SquircleComponent } from '@shared/components';
import { I18NextModule } from 'angular-i18next';
import { NgOptimizedImage } from '@angular/common';
import { RippleDirective } from '@shared/directives';

type QrActionBtn = {
  class: string;
  icon: string;
  headline: string;
  title: string;
};

@Component({
  standalone: true,
  selector: 'cheelee-qr-dialog',
  templateUrl: './qr-dialog.component.html',
  styleUrl: './qr-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DialogWrapperComponent,
    I18NextModule,
    IconComponent,
    NgOptimizedImage,
    RippleDirective,
    SquircleComponent,
    QrComponent,
  ],
})
export class QrDialogComponent {
  private readonly overlayService = inject(OverlayService);

  protected readonly actionBtns: QrActionBtn[] = [
    { class: 'chl-qr-btn--google-play', icon: 'google-play-icon', headline: 'Get it on', title: 'Google Play' },
    { class: 'chl-qr-btn--get-apps', icon: 'get-apps-icon', headline: 'Download on the', title: 'GetApps' },
    { class: 'chl-qr-btn--app-store', icon: 'apple-icon', headline: 'Download on the', title: 'App Store' },
  ];

  protected onClose(): void {
    return this.overlayService.close(ModalsNames.Qr);
  }
}
